export default __webpack_public_path__ + "static/download-appstore-badge-2ea643e03ec8811735b29fdc4f7b3dd8.svg";